export enum EPersonType {
  PF = 0,
  PJ = 1,
}
